export default __webpack_public_path__ + "static/media/regenz-logo-color.645ca25d.svg";